///home/cockskiz/new.greatlysocial.com/frontend/src/components/ScrollToTop.js
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop () {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)        // jump to top on every path change
  }, [pathname])

  return null                    // this component renders nothing
}
